<section class="tile-grid__grid" [style.--columns]="columns">
  @for (tile of tiles; track tile) {
    <div class="tile-grid__card">
      <ds-link
        tabindex="0"
        role="link"
        [linkConfig]="getLinkConfig(tile)"
        [externalSiteModalConfig]="externalSiteModalConfig"
      >
        <icon
          class="tile-grid__icon"
          [name]="tile.icon"
          [config]="getIconConfiguration(tile)"
          [style.--icon-color]="tile.icon_color"
        >
        </icon>
        <h5 class="tile-grid__title">{{ tile.title }}</h5>
        <p [innerHtml]="tile.description"></p>
      </ds-link>
    </div>
  }
</section>
